var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-home-page',{attrs:{"logo":"/capsiminbox/images/CapsimInbox_IAP_Logo_Colors.png"}},[_c('login-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }